const DataBureau = [
  {
    id: "fg4858465",
    nom: "Dounia Saez",
    fonction: "présidente",
    image:
      "https://img.freepik.com/vecteurs-libre/femme-scientifique-atome_23-2148403445.jpg?size=626&ext=jpg&ga=GA1.1.837209848.1677940872&semt=ais",
  },
  {
    id: "fjgk7843",
    nom: "Terence Saulnier",
    fonction: "trésorier",
    image:
      "https://img.freepik.com/vecteurs-libre/developpement-vaccin-illustre_23-2148540562.jpg?t=st=1706002693~exp=1706003293~hmac=94a03147b5cfa32bd132867d07d56019cfdcb67dbc9248385aec42a9a5e92f32",
  },
  {
    id: "fkjg7854",
    nom: "Pierre Rambourg",
    fonction: "secrétaire",
    image:
      "https://img.freepik.com/vecteurs-libre/scientifique-travaillant_23-2148487902.jpg?t=st=1706002693~exp=1706003293~hmac=c79dd8292f06a8f0412c1939876cc38cbe88004a2a5999cb61655adde9e351d5",
  },
];

export default DataBureau;
